import React from "react"

import styled from "styled-components"

import { useLocalization } from "@izettle/lingo-client"
import { colors, IconErrorFilledSmall, spacing, typography } from "@izettle/otto"
import { SvgIcon } from "@izettle/react"

const ErrorContainer = styled.div`
  display: flex;
  flex-direction: row;

  ${typography.regular};
  color: ${colors.text.error};
`

const ErrorIcon = styled(SvgIcon).attrs({
  icon: IconErrorFilledSmall,
})`
  margin-right: ${spacing.xxSmall};
`

const ErrorContent = styled.div``

export const FieldError: React.FC = ({ children }) => {
  const { text } = useLocalization()

  return (
    <ErrorContainer>
      <ErrorIcon title={text("ERROR_TITLE")} />
      <ErrorContent>{children}</ErrorContent>
    </ErrorContainer>
  )
}
